<template>
    <div class="wrapper wrapper4">
        <div class="swiper features-swiper">
            <div class="btn btn-prev"></div>
            <div class="btn btn-next"></div>
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <img
                        src="https://static.web.sdo.com/xyx/pic/act/2026/0902_Join/swiper-img-7.png"
                        alt=""
                    />
                </div>
                <div class="swiper-slide">
                    <img
                        src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/swiper-img-1.png"
                        alt=""
                    />
                </div>
                <div class="swiper-slide">
                    <img
                        src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/swiper-img-2.png"
                        alt=""
                    />
                </div>
                <div class="swiper-slide">
                    <img
                        src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/swiper-img-3.png"
                        alt=""
                    />
                </div>
                <div class="swiper-slide">
                    <img
                        src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/swiper-img-4.png"
                        alt=""
                    />
                </div>
                <div class="swiper-slide">
                    <img
                        src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/swiper-img-5.png"
                        alt=""
                    />
                </div>
                <div class="swiper-slide">
                    <img
                        src="https://static.web.sdo.com/xyx/pic/act/2026/0902_Join/swiper-img-6.png"
                        alt=""
                    />
                </div>
            </div>
            <div class="features-pagination"></div>
        </div>
    </div>
</template>

<script setup>
import "swiper/css";
import Swiper from "swiper";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { onMounted } from "vue";

onMounted(() => {
    new Swiper(".features-swiper", {
        spaceBetween: 156,
        slidesPerView: 2.2,
        centeredSlides: true,
        loop: true,
        modules: [Autoplay, Pagination, Navigation],
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        pagination: {
            el: ".features-pagination",
            clickable: true
        },
        navigation: {
            nextEl: ".features-swiper .btn-next",
            prevEl: ".features-swiper .btn-prev"
        }
    });
});
</script>

<style lang="scss">
.wrapper4 {
    background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/5.jpg");
    height: 904px;
    .features-swiper {
        position: absolute;
        width: 1920px;
        left: 50%;
        margin-left: -960px;
        top: 300px;
        .swiper-slide {
            position: relative;
            box-sizing: border-box;
            padding: 4px;
            background-color: #f6c872;
            img {
                width: 100%;
            }
            &::before {
                position: absolute;
                content: "";
                width: 100%;
                height: 100%;
                left: 0px;
                top: 0px;
                background-color: rgba(0, 0, 0, 0.7);
                transition: 0.6s;
            }
            &.swiper-slide-active {
                &::before {
                    background-color: rgba(0, 0, 0, 0);
                }
            }
        }
        .features-pagination {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 50px;
            .swiper-pagination-bullet {
                width: 18px;
                height: 18px;
                cursor: pointer;
                box-sizing: border-box;
                border: 2px solid #f6c872;
                transform: rotate(45deg);
                margin: 0px 10px;
                &.swiper-pagination-bullet-active {
                    background: #f6c872;
                }
            }
        }
        .btn {
            position: absolute;
            z-index: 2;
            width: 51px;
            height: 63px;
            top: 50%;
            cursor: pointer;
            margin-top: -82px;
            background-image: url("https://static.web.sdo.com/xyx/pic/act/2026/0902_Join/swiper-btns.png");
            background-repeat: no-repeat;
            &.btn-prev {
                left: 50%;
                margin-left: -510px;
                background-position: 0px 0px;
                &:hover {
                    background-position: 0px -83px;
                }
            }
            &.btn-next {
                right: 50%;
                margin-right: -510px;
                background-position: -96px 0px;
                &:hover {
                    background-position: -96px -83px;
                }
            }
        }
    }
}
</style>
